


import { Stack, Col } from "react-bootstrap";
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import SuccessIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';
import { TextButton } from "Components/Button";

export const FloatingCallToAction = ({ title, text, children }) => {

    return (
        <Col lg={3} className="call-to-action-con col-12 col-sm-11 col-md-7 col-lg-4 col-xl-3 mx-auto m-md-0 order-0 ">
            <div className="call-to-action mt-5 mb-5">
                <div className="mb-0"><span className="action-title">{title}</span></div>
                <p className="action-text">{text}</p>
                {children}
            </div>
        </Col>
    );
}

export const FloatingCallToActionEmpty = ({ children }) => {

    return (
        <Col lg={4} className="call-to-action-con mb-2">
            <div className="call-to-action">
                {children}
            </div>
        </Col>
    );
}